import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigation } from '@refinedev/core';
import { unpublishStudy } from '../domain/studies.api';
import logger from '@/core/services';
import { HttpError } from '@refinedev/core';
import { StudyDetail } from '@aphp-ema/common/study';

export const useUnpublishStudy = () => {
  const queryClient = useQueryClient();
  const { edit } = useNavigation();

  const { mutate, isLoading } = useMutation<StudyDetail, HttpError, string>({
    mutationFn: unpublishStudy,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['admin/studies', { exact: true }]);
      queryClient.invalidateQueries(['admin/studies', data.id]);
      edit('admin/studies', data.id);
    },
    onError: (error: HttpError) => {
      logger.error('Error unpublishing study:', error);
    },
  });

  return { unpublishStudy: mutate, isLoading };
};
